//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AcordoTabela from './AcordoTabelaDash';
import acordoMixin from './acordo';
import {
  getMoney,
} from '../../../../../common/functions/helpers';
import { skipLoading } from '../../../../../common/functions/loading';

export default {
  name: 'DashboardNegociacao',
  mixins: [acordoMixin],
  data() {
    return {
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      usuarioUnidadeNegocioResources: this.$api.usuarioUnidadeNegocio(this.$resource),
      unidadesNegocio: [],
      unidadeNegocio: null,
      periodos: [],
      statusNegociacoes: [],
      tiposNegociacoes: [],
      negociacoes: [],
      periodoNegociacao: null,
      consolidadoNegociacao: {},
      bloquearConsulta: false,
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() { },
      },
      orcamentosListItens: null,
      fluxos: [
        { id: 1, nome: this.$t('label.orcamento') },
        { id: 2, nome: this.$t('label.transferencia') },
      ],
      justificarOrcamento: {
        observacao: '',
      },
      motivo: '',
      objetosSelecionados: [],
      podeAprovar: false,
      podeReprovar: false,
      tipoFluxo: '',
      statusOrcamento: 'AGUARDANDO_APROVACAO',
      filtros: {},
      carregado: false,
      carregandoBox: false,
      carregandoTable: false,
      saldoRepresentante: 0,
      paginas: 0,
      buscarComParametro: false,
    };
  },
  props: {
    parametros: {
      type: Object,
      default: {},
    },
  },
  components: {
    AcordoTabela,
  },
  methods: {
    getMoney,
    requestGetUnidadesNegocio() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.usuarioUnidadeNegocioResources.listarAtivos()
          .then((response) => {
            this.unidadesNegocio = response.data;
            resolve();
          }).catch(reject);
      });
    },
    carregarDashboard() {
      if (this.periodoNegociacao) {
        this.filtros.periodo = this.periodoNegociacao;
      } else {
        delete this.filtros.periodo;
      }
      if (this.unidadeNegocio) {
        this.filtros.idUnidadeNegocio = this.unidadeNegocio;
      } else {
        delete this.filtros.idUnidadeNegocio;
      }

      this.requestCargaConsolidados(this.filtros);
      this.requestCarregarNegociacoes();
    },
    recarregarDashboard() {
      this.$refs.acordoTabela.refazPaginacao();

      this.carregarDashboard();
    },
    filtrarFluxos(filtro) {
      this.$refs.acordoTabela.refazPaginacao();
      if (this.buscarComParametro) {
        this.requestCarregarNegociacoes(this.filtrosPorParametros());
        this.buscarComParametro = false;
      } else {
        this.requestCarregarNegociacoes(filtro);
      }
    },
    requestCargaConsolidados(filtro = {}) {
      skipLoading();
      this.carregandoBox = true;
      this.dashboardNegociacaoResources.listarDashNegociacoes(filtro)
        .then((response) => {
          this.consolidadoNegociacao = {};
          response.data.forEach((item) => {
            this.consolidadoNegociacao[item.status.toLowerCase()] = item.consolidado;
          });
          this.carregandoBox = false;
        })
        .catch((err) => {
          this.$error(this, err);
          this.carregandoBox = false;
        });
    },
    requestCarregarNegociacoes(filtros = null, numeroPagina = 1, cb) {
      this.bloquearConsulta = true;
      if (filtros) {
        this.filtros = this.prepararFiltro(filtros);
      }
      this.filtros.tamanhoPagina = 20;
      this.filtros.numeroPagina = numeroPagina;

      skipLoading();
      this.carregandoTable = true;
      this.dashboardNegociacaoResources.listarNegociacoes(this.filtros)
        .then((response) => {
          delete this.filtros.idCliente;
          delete this.filtros.idAcordo;

          this.bloquearConsulta = false;
          const fluxos = response.data.resposta;

          const qtdeRegistros = response.data.quantidadeRegistrosPagina;
          this.paginas = Math.ceil(qtdeRegistros / this.filtros.tamanhoPagina);

          this.negociacoes = [];
          this.negociacoes.push(...fluxos);
          this.carregandoTable = false;
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          this.$error(this, err);
          this.bloquearConsulta = false;
          this.carregandoTable = false;
        });
    },
    cleanTableNoResult(cb) {
      this.negociacoes = [];
      if (cb) {
        cb();
      }
    },
    prepararFiltro(filter) {
      const filtro = Object.assign({}, this.filtros);

      filtro.meuPassoPendente = filter.meuPassoPendente;
      filtro.meuPassoAprovado = filter.meuPassoAprovado;
      if (filter.status) {
        filtro.status = filter.status;
      } else {
        delete filtro.status;
      }
      if (filter.tipoAcordo) {
        filtro.tipoAcordo = filter.tipoAcordo;
      } else {
        delete filtro.tipoAcordo;
      }
      if (filter.idCliente) {
        filtro.idCliente = filter.idCliente;
      } else {
        delete filtro.idCliente;
      }
      if (filter.idAcordo) {
        filtro.idAcordo = filter.idAcordo;
      } else {
        delete filtro.idACordo;
      }
      if (filter.idMarca) {
        filtro.idMarca = filter.idMarca;
      } else {
        delete filtro.idMarca;
      }
      if (filter.idLinhaProduto) {
        filtro.idLinhaProduto = filter.idLinhaProduto;
      } else {
        delete filtro.idLinhaProduto;
      }
      if (filter.idFamilia) {
        filtro.idFamilia = filter.idFamilia;
      } else {
        delete filtro.idFamilia;
      }
      if (filter.idProduto) {
        filtro.idProduto = filter.idProduto;
      } else {
        delete filtro.idProduto;
      }
      if (filter.idTipoLinhaOrcamento) {
        filtro.idTipoLinhaOrcamento = filter.idTipoLinhaOrcamento;
      } else {
        delete filtro.idTipoLinhaOrcamento;
      }
      return filtro;
    },
    requestCarregarStatusNegociacoes() {
      this.dashboardNegociacaoResources.listarStatusNegociacoes()
        .then((response) => {
          this.statusNegociacoes = response.data.resposta;
        });
    },
    requestCarregarTiposNegociacoes() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.dashboardNegociacaoResources.listarTiposNegociacoes()
          .then((response) => {
            this.tiposNegociacoes = response.data.resposta;
            resolve();
          }).catch(reject);
      });
    },
    requestCargaPeriodos() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.dashboardNegociacaoResources.listarPeriodos()
          .then((response) => {
            this.periodos = response.data;
            resolve();
          }).catch(reject);
      });
    },
    filtrosPorParametros() {
      const filter = { status: 'AGUARDANDO_APROVACAO' };
      filter.meuPassoPendente = true;
      if (this.parametros) {
        if (this.parametros.idCliente) {
          filter.idCliente = this.parametros.idCliente;
        }
        if (this.parametros.idAcordo) {
          filter.idAcordo = this.parametros.idAcordo;
        }
      }
      return filter;
    },
    temParametro() {
      return this.parametros && this.parametros.idAcordo;
    },
    abreCarrega() {
      if (this.carregado) {
        return;
      }

      window.setTimeout(() => {
        this.requestCarregarTiposNegociacoes()
          .then(this.requestGetUnidadesNegocio)
          .then(this.requestCargaPeriodos)
          .then(() => {
            this.requestCargaConsolidados();
            if (this.temParametro()) this.buscarComParametro = true;
            this.carregado = true;
          })
          .catch((err) => {
            this.$toast.create(this.$t(err), 'snack', 3E3);
          });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashboardNegociacao.vue?vue&type=script&lang=js&